// extracted by mini-css-extract-plugin
export default {"title":"styles_title__VSit+","subTitle":"styles_subTitle__A0WvH","text":"styles_text__xiMrx","smallText":"styles_smallText__xyMCS"};